import useSWRMutation from 'swr/mutation'

import { reservationApi, tokenOptions } from '../../apis/suitebookClient'

export const useDownloadReceiptApi = (id: string | number, token: string) => {
  // This GET claims a counted view; background read revalidation would spend it.
  const { trigger, error, isMutating, reset } = useSWRMutation(
    [`/reservations/${id}/receipts`, token],
    (_, { arg }: { arg: number }) =>
      reservationApi
        .getReservationReceipt(Number(id), arg, tokenOptions(token))
        .then((res) => res.data),
    { revalidate: false }
  )
  return { trigger, error, isLoading: isMutating, reset }
}
